import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { LocationInfo, LocationInfoType } from 'record-it-utils/location/GeolocationManager/GeolocationManager';
import { GeolocationManagerContext } from '../../context/GeolocationManagerContext';

/**
 * @performance - This hook causes a rerender as soon as the effect is called. This can be optimized.
 */
export function useLocationInfo() {
  const $ = _c(4);
  const {
    manager
  } = useContext(GeolocationManagerContext);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: LocationInfoType.Pending
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [locationInfo, setLocationInfo] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== manager) {
    t1 = () => {
      const disposable = manager.bindGeolocation(newLocationInfo => {
        setLocationInfo(newLocationInfo);
      });
      return () => disposable.dispose();
    };
    t2 = [manager];
    $[1] = manager;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return locationInfo;
}